/**************************************************************************************
 *  Objetivo: Page Agentes
 *  Autor: Luiz Gustavo
 *  Data: 12/01/2023
 *  Versão: 1.0
 **************************************************************************************/

import ContainerAgentes from "../../components/ContainerAgentes";

function Agentes() {
  return (
      <div className="agentes">
        <h1 className="titulo-agentes">Agentes</h1>
        <ContainerAgentes />
      </div>
  );
}

export default Agentes;
